import { CompanyCreate } from "./CompanyCreate";
import { CompanyEdit } from "./CompanyEdit";
// GAVION: Leads list and lead page replace the upstream list/show (spec 10 §5.3, §5.5); loaded on demand (quality pass)
import { LeadListPage, LeadShow } from "../../gavion/routes/lazyPages";

export default {
  list: LeadListPage,
  create: CompanyCreate,
  edit: CompanyEdit,
  show: LeadShow,
};
